import { HttpHelper, HttpServiceParams } from 'rbh-merchant-core';
import { envConfig } from '../../../../../config';
import { POS_REQUEST_ID_LIST } from './pos-constant';

class PosServiceClass {
  getPosCurrentStep = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: envConfig.hostname + `v1/merchant/company-admin/pos/current-step/${params.data}`,
      id: POS_REQUEST_ID_LIST.GET_POS_CURRENT_STEP
    });
  }

  patchPosMenus = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/pos/menus',
      data: params.data,
      id: POS_REQUEST_ID_LIST.PATCH_POS_MENUS
    });
  }

  getPosProvider = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: envConfig.hostname + 'v1/merchant/company-admin/pos/pos-provider',
      id: POS_REQUEST_ID_LIST.GET_POS_PROVIDER
    });
  }

  updatePos = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/pos/update-pos',
      data: params.data,
      id: POS_REQUEST_ID_LIST.PATCH_UPDATE_POS
    });
  }

  postMhStatus = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: envConfig.hostname + 'v1/merchant/company-admin/pos/mh-status',
      data: params.data,
      id: POS_REQUEST_ID_LIST.POST_MH_STATUS
    });
  }

  getMenuModifierItem = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: envConfig.hostname + `v1/merchant/company-admin/pos/menus-modifier-item/${params.data}`,
      id: POS_REQUEST_ID_LIST.GET_MENU_MODIFIER_ITEM
    });
  }

  patchMenuModifierItem = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/pos/menus-modifier-item',
      data: params.data,
      id: POS_REQUEST_ID_LIST.PATCH_MENU_MODIFIER_ITEM
    });
  }

  patchCancelPos = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/pos/cancel-pos',
      data: params.data,
      id: POS_REQUEST_ID_LIST.PATCH_CANCEL_POS
    });
  }
}

export const PosService = new PosServiceClass();
